import { groupBy } from "lodash";

interface Location {
  city: string;
  streetAddress: string;
  id: string;
}

interface ToGroupLocationsReturn {
  city: string;
  streetAddresses: { name: string; locationId: string }[];
}

export function toGroupLocations(
  locations: Location[]
): ToGroupLocationsReturn[] {
  const returnedLocations: ToGroupLocationsReturn[] = [];
  const groupByCity = groupBy(locations, (location) => location.city);
  for (const city in groupByCity) {
    returnedLocations.push({
      city,
      streetAddresses: groupByCity[city].map((location) => ({
        name: location.streetAddress,
        locationId: location.id,
      })),
    });
  }

  return returnedLocations;
}
